import { ERuntimeSettings } from 'shared/common/types/runtimeSettings';
import { useApplicationContext } from 'shared/common/utils/applicationContext';

const DRAFT_ACTION_QUERY_PARAM = 'draftAction';
const APPLICATION_ID_QUERY_PARAM = 'applicationId';
const BANK_ID_QUERY_PARAM = 'bankId';

/** Что анкета должна сделать с черновиком. Пустой `/short-form/` занят другими входами, в том числе
    ловушками, поэтому намерение передаём явным флагом, а не отсутствием параметров. */
export type TDraftAction = 'new' | 'continue';

export interface IShortFormUrlOptions {
  draftAction: TDraftAction;
  applicationId?: number | null;
  bankId?: number | null;
}

export const useBuildShortFormUrl = () => {
  const { config } = useApplicationContext();

  /* РС читаем в момент сборки ссылки, а не хука: хук зовут обе группы, а getStrict без настройки
     бросает — в группе A этот код не исполняется */
  return ({ draftAction, applicationId, bankId }: IShortFormUrlOptions): string => {
    const searchParams = new URLSearchParams({ [DRAFT_ACTION_QUERY_PARAM]: draftAction });

    if (applicationId != null) {
      searchParams.set(APPLICATION_ID_QUERY_PARAM, String(applicationId));
    }

    if (bankId != null) {
      searchParams.set(BANK_ID_QUERY_PARAM, String(bankId));
    }

    return `${config.getStrict<string>(ERuntimeSettings.shortFormBaseUrl)}?${searchParams.toString()}`;
  };
};
